"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSnakeCase = exports.toCamelCase = void 0;

/**
 * Transforms snakecase strings to camelcase.
 * 
 * @param {String} string The string you want to transform to camelcase.
 */
var toCamelCase = function toCamelCase() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/_([a-z])/g, function (firstLetter) {
    return firstLetter[1].toUpperCase();
  });
};
/**
 * Transforms all strings to snakecase.
 * 
 * @param {String} string The string you want to transform to snakecase.
 */


exports.toCamelCase = toCamelCase;

var toSnakeCase = function toSnakeCase() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (letter) {
    return letter.toLowerCase();
  }).join('_');
};

exports.toSnakeCase = toSnakeCase;